import { TChatDashboardsSettingsAction } from '../chatDashboardsSettings/actions/types';
import { CHAT_DASHBOARDS_SETTINGS_ACTION_SET, IChatDashboardsSettingsActionSetAction } from './types';

export const chatDashboardsSettingsActionSet = (
    chatDashboardsSettingsAction: TChatDashboardsSettingsAction
): IChatDashboardsSettingsActionSetAction => {
    return {
        type: CHAT_DASHBOARDS_SETTINGS_ACTION_SET,
        chatDashboardsSettingsAction
    }
};
